import { HttpClient, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { parseToProjectModules, ProjectModules, ProjectModulesDto, ProjectModulesUpdateDto, parseToProjectModulesUpdateDto } from "../types/project-module.type";
import { map, Observable } from "rxjs";

function getBaseUrl (projectNumber: string): string {
  return `api/projects/${ projectNumber }/module-relations`;
}

@Injectable({
  providedIn: "root"
})
export class ProjectModuleService {
  private readonly _httpClient: HttpClient = inject(HttpClient);

  /**
   * Fetches ProjectModules from Backend for a given ProjectNumber
   *
   * @param projectNumber The Number of the Project
   */
  public getModules (projectNumber: string): Observable<ProjectModules> {
    return this._httpClient.get<ProjectModulesDto>(getBaseUrl(projectNumber))
      .pipe(
        map(parseToProjectModules)
      );
  }

  /**
   * Update checked Status for Modules of a given ProjectNumber
   * @param projectNumber Number of the Project
   * @param modules The Updated Modules
   * @returns a HttpResponse without a body for the component to work with the status code etc.
   */
  public updateModules (projectNumber: string, modules: ProjectModules): Observable<HttpResponse<void>> {
    const parsedModules: ProjectModulesUpdateDto = parseToProjectModulesUpdateDto(modules);

    return this._httpClient.put<never>(getBaseUrl(projectNumber), parsedModules, { observe: "response" });
  }
}
